import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async uploadFile({ commit }, data) {
      try {
        return await api.post('/upload', data)
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
